import { useQuery } from '@tanstack/react-query';

import { publicApiClient } from '@/lib/api/publicClient';

import { sessionDetailDtoSchema } from '../schemas/sessionSchemas';

// Loads the PROVISIONAL view for a shared workflow link (/wf/{slug}) when no
// recipient token is present: branding + run options, WITHOUT creating a session,
// so the mobile-number/OTP gate is branded and the mobile-only rule applies
// before anything exists. The session is created only on OTP verification. The
// returned DTO has a blank id + publicToken to mark it provisional.
export function usePublicWorkflowIntro(slug: string | undefined) {
  return useQuery({
    queryKey: ['publicWorkflowIntro', slug ?? ''],
    queryFn: async ({ signal }) => {
      const raw = await publicApiClient
        .get(`api/v1/public/workflows/${slug}/intro`, { signal })
        .json();
      return sessionDetailDtoSchema.parse(raw);
    },
    enabled: !!slug,
    staleTime: 60_000,
    retry: false,
  });
}
